import { FilterChevronDownIcon, FilterChevronUpIcon } from '@icons'
import cn from 'classnames'
import { useDropDownMenu } from 'mmfintech-commons'
import type { ReactNode } from 'react'

import './FiltersDropDown.scss'

interface Props {
  icon?: ReactNode
  caption?: string
  dropDown: ReactNode
  alternative?: boolean
}

function FiltersDropDown({ icon, caption = '', dropDown, alternative }: Props) {
  const { visible, toggleDropDown } = useDropDownMenu()

  return (
    <span className='dropdown-wrapper'>
      {alternative ? (
        !!icon && (
          <div className='icon-container' onClick={toggleDropDown}>
            {icon}
          </div>
        )
      ) : (
        <div className={cn('dropdown-button', { opened: visible })} onClick={toggleDropDown}>
          <span>
            {!!icon && <div className='icon'>{icon}</div>}
            {caption}
          </span>
          <span className='chevron'>{visible ? <FilterChevronUpIcon /> : <FilterChevronDownIcon />}</span>
        </div>
      )}
      <div className={cn('dropdown-content', { opened: visible, alternative })}>{dropDown}</div>
    </span>
  )
}

export default FiltersDropDown
